<div class="full-width-image-section home-top">
    <div class="arrow-up">
        <next-topbar></next-topbar>
        <next-menu></next-menu>

        <div class="container white">
            <div class="row">
                <div class="col-sm-12 text-center">
                    <h1>Indboforsikring</h1>
                </div>
            </div>

            <p class="home-insurance-text">
                NEXT er blevet til easySure, men du kan stadig vælge de samme gode forsikringer, faktisk med lidt bedre dækning. Ingen binding og ingen skjulte gebyrer.
            </p>

            <div class="row">
                <div class="col-xs-12">
                    <div class="icon-bg center no-circle">
                        <div class="icon-wrap">
                            <i class="nf nf-home-icon-v3"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="container">
    <div class="row">
        <div class="col-sm-12 text-center">
            <br />
            <br />
            <a href="https://ssp.easysure.dk/sales-journey/privateLiabilityAndContent?accept-language=da/?kpcid=20000131" class="btn btn-success calculate-btn">Beregn hos easySure</a>
            <br />
            <br />
        </div>
    </div>
</div>

<trustpilot-carousel></trustpilot-carousel>

<div class="gray-bg">
    <div class="container">
        <next-faqarticle [category]="'FAQ_HOME'"></next-faqarticle>
    </div>
</div>

<nicetoknow [pagecode]="'INSURANCE_HOME_NICETOKNOW'"></nicetoknow>

<next-footer></next-footer>
